import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, Stack } from '@mui/material';
import { PageHeader } from '../PageHeader';
import { PageFooter } from '../PageFooter';
import { EmailTriggerButton } from '../EmailTrigger';

import { SupportModeBanner } from '../SupportModeBanner';

export const PageLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <Stack sx={{ bgcolor: 'primary.light', height: '100vh' }}>
      <SupportModeBanner />
      <PageHeader />
      <Stack id="page-layout-root" sx={{ height: '100%', overflow: 'auto', flexGrow: 1 }}>
        <Container id="page-container-root" sx={{ mt: 10, mb: 10, flexGrow: 1 }}>
          {children ?? <Outlet />}
        </Container>
        <PageFooter />
      </Stack>
      <EmailTriggerButton />
    </Stack>
  );
};
